<div class="main" [ngClass]="{'rtl': headerRTL}">
  <div class="logo">
    <img src="assets/1_CARRIER-17.svg" alt="">
  </div>
  <div class="unit">
    <div class="parentName">
      {{units[0]?.parent_name}}
    </div>
    <div class="selectUnit">
      <div class="unitSelection">
        <mat-select style="color: #fff;" [(ngModel)]="selectedUnit" title="{{selectedUnit.name}}">
          <mat-option *ngFor="let unit of units" (click)="selectUnit(unit)" [value]="unit"
            title="{{unit.parent_name}} - {{unit.name}}">
            {{unit.name}}
          </mat-option>
        </mat-select>
      </div>
    </div>
  </div>

  <div class="navbar">

    <div class="menu">
      <i class="material-icons" [matMenuTriggerFor]="mainSettings">menu</i>

      <mat-menu #mainSettings="matMenu">
        <div mat-menu-item class="user" disabled>
          <div class="icon" *ngIf="userName">
            {{userName.substr(0, 1)}}
          </div>
          <div class="name" title="{{userName}}">
            {{userName}}
          </div>
        </div>
        <button mat-menu-item [matMenuTriggerFor]="shipments">{{'HEADER.shipments' | translate}}</button>
        <button *ngIf="roles.owner || roles.unit || roles.accountingAdmin || roles.reportAdmin" mat-menu-item
          routerLink="/reports">{{'HEADER.reports' | translate}}</button>
        <button mat-menu-item [matMenuTriggerFor]="jspl">{{'HEADER.jspl' |
          translate}}</button>
        <button mat-menu-item [matMenuTriggerFor]="partial">{{'HEADER.partialregistrationdashboard' |
          translate}}</button>
        <button mat-menu-item *ngIf="roles.owner || roles.unit" routerLink="/user">{{'HEADER.userManagement' |
          translate}}</button>
        <button mat-menu-item routerLink="/loadDashboard">{{'HEADER.load_dashboard' |
          translate}}</button>
        <button mat-menu-item routerLink="/freeLoadDashboard">{{'HEADER.free_load_dashboard' |
          translate}}</button>
        <button mat-menu-item routerLink="/cementLoadDashboard">{{'HEADER.cement_load_dashboard' |
          translate}}</button>
        <button mat-menu-item *ngIf="roles.owner || roles.unit" routerLink="/unit">{{'HEADER.unitManagement' |
          translate}}</button>
        <button mat-menu-item routerLink="/partialRegistrationDashboard">{{'HEADER.partialregistrationdashboard' |
          translate}}</button>
        <mat-menu #jspl="matMenu">
          <button mat-menu-item routerLink="/externalParkingVehicles">{{'HEADER.externalparkingvehicles' |
            translate}}</button>
          <button mat-menu-item routerLink="/inPlantVehicles">{{'HEADER.inPlantVehicles' |
            translate}}</button>
          <button mat-menu-item routerLink="/enRouteVehicles">{{'HEADER.enRouteVehicles' | translate}}</button>
          <button mat-menu-item routerLink="/vehiclesAtCustomerSite">{{'HEADER.vehiclesatcustomerssite' |
            translate}}</button>
          <button mat-menu-item routerLink="/vehiclesUpdateStatus">{{'HEADER.vehiclesupdatestatus' |
            translate}}</button>
          <button mat-menu-item routerLink="/closedTripsDetail">{{'HEADER.closedtripsdetails' | translate}}</button>
          <!-- <button mat-menu-item routerLink="/partialRegistration">{{'HEADER.partialregistration' |
            translate}}</button> -->
        </mat-menu>
        <mat-menu #partial="matMenu">
          <button mat-menu-item routerLink="/partialRegistration">{{'HEADER.registration' |
            translate}}</button>
          <button mat-menu-item routerLink="/partialRegistrationDashboard">{{'HEADER.dashboard' |
            translate}}</button>
        </mat-menu>

        <button mat-menu-item *ngIf="roles.owner || roles.fleet" [matMenuTriggerFor]="driver">{{'HEADER.driver' |
          translate}}</button>
        <button mat-menu-item *ngIf="roles.owner || roles.fleet" routerLink="/vehicles">{{'HEADER.vehicle' |
          translate}}</button>
        <button mat-menu-item *ngIf="roles.owner || roles.accounting" [matMenuTriggerFor]="accounts">{{'HEADER.accounts'
          | translate}}</button>
        <button mat-menu-item *ngIf="this.country == 'IN'" [matMenuTriggerFor]="bayan">{{'HEADER.bayan' |
          translate}}</button>
        <button mat-menu-item routerLink="/rateCard">{{'HEADER.rateCard' | translate}}</button>
        <button mat-menu-item *ngIf="roles.owner || roles.fleet" routerLink="/scorecard">{{'HEADER.scorecard' |
          translate}}</button>
        <button mat-menu-item *ngIf="roles.owner || roles.shippers" routerLink='/myShippers'>{{'HEADER.myShippers' |
          translate}}</button>
        <button mat-menu-item [matMenuTriggerFor]="settings">{{'HEADER.settings' | translate}}</button>
        <button mat-menu-item [matMenuTriggerFor]="language">Languages</button>
        <button mat-menu-item routerLink="/help-desk">{{'HEADER.help'| translate}} </button>
        <button mat-menu-item (click)="logout()">{{'HEADER.logout' | translate}}</button>
      </mat-menu>

      <mat-menu #shipments="matMenu">
        <button routerLink="/shipmentsDashboard" mat-menu-item>{{'HEADER.myShipments' | translate}}</button>
        <button routerLink="/postShipment" *ngIf="roles.owner || roles.postShipment"
          mat-menu-item>{{'HEADER.postShipment' | translate}}</button>
        <!-- <button routerLink="/deletedShipments" mat-menu-item>{{'HEADER.deletedShipments' | translate}}</button> -->
      </mat-menu>

      <mat-menu #settings="matMenu">
        <button mat-menu-item routerLink="/unitSettings">{{'HEADER.unit' | translate}}</button>
        <button mat-menu-item *ngIf="roles.owner || roles.accounting" routerLink="/accountSettings">{{'HEADER.accounts' | translate}}</button>
        <button mat-menu-item routerLink="/dashboardSettings">{{'HEADER.overview' | translate}}</button>
        <button mat-menu-item routerLink="/nozone">{{'HEADER.nozone' | translate}}</button>
        <!-- <button mat-menu-item routerLink="/controlRoom">{{'HEADER.controlRoom' | translate}}</button> -->
        <!-- {{'HEADER.lanesOpt' | translate}} -->
        <!-- <button mat-menu-item routerLink="/taxSettings">{{'HEADER.tax' | translate}}</button> -->
      </mat-menu>


      <mat-menu #language="matMenu">
        <button mat-menu-item *ngFor="let lang of languages" (click)="changeLang(lang.code)">{{lang.name}}</button>
      </mat-menu>

      <mat-menu #driver="matMenu">
        <button mat-menu-item routerLink="/drivers">{{'HEADER.myDrivers' | translate}}</button>
        <!-- <button mat-menu-item>Driver Path</button> -->
        <button mat-menu-item routerLink="/spotDrivers">{{'HEADER.spotDrivers' | translate}}</button>
        <button mat-menu-item routerLink="/attendance-list">{{'HEADER.attendance_salary' | translate}}</button>
        <!-- <button mat-menu-item routerLink="/attendance">{{'HEADER.driverAttendance' | translate}}</button> -->
      </mat-menu>
      <mat-menu #bayan="matMenu">
        <button mat-menu-item routerLink="/registeredDrivers">{{'HEADER.registeredDrivers' | translate}}</button>
        <button mat-menu-item routerLink="/registeredVehicles">{{'HEADER.registeredVehicles' | translate}}</button>
      </mat-menu>

      <mat-menu #accounts="matMenu">
        <button routerLink="/invoices" mat-menu-item>{{'HEADER.invoice_dashboard' | translate}}</button>
        <button routerLink="/bills" mat-menu-item>{{'HEADER.carrier_billing_dboard' | translate}}</button>
        <button routerLink="/consolidatedInvoices" mat-menu-item>{{'HEADER.billing_dashboard' | translate}}</button>
        <button routerLink="/payment-voucher" mat-menu-item>{{'HEADER.payment_voucher' | translate}}</button>
        <button mat-menu-item routerLink="/vehiclesDashboard">{{'VEHICLE.vehicleDashboard' | translate}}</button>
        <button mat-menu-item routerLink="/payment-advice">{{'HEADER.payment_advice' | translate}}</button>
        <button mat-menu-item routerLink="/credit-notes">{{'HEADER.credit_notes' | translate}}</button>
        <button mat-menu-item routerLink="/debit-notes">{{'HEADER.debit_notes' | translate}}</button>
        <button mat-menu-item routerLink="/mwgDashboard">{{'HEADER.mwg'| translate}} </button>
        <button mat-menu-item routerLink="/odcDashboard">{{'HEADER.odcDashboard'| translate}} </button>
        <!-- <button  mat-menu-item>{{'HEADER.platform_invoice' | translate}}</button> -->
      </mat-menu>
      <mat-menu #vehicle="matMenu">
        <button mat-menu-item routerLink="/vehicles">{{'HEADER.myVehicle' | translate}}</button>
      </mat-menu>
      <mat-menu #vehicle="matMenu">
        <button mat-menu-item routerLink="/scorecard">{{'HEADER.scorecard' | translate}}</button>
      </mat-menu>
    </div>

    <div class="notificationTrails" (click)="$event.stopPropagation()">
      <i class="material-icons" (click)="toggleNotifications(); ">
        notifications
      </i>
      <div class="notificationsBox" [hidden]="!showNotificationBox">
        <span class="dropdown-menu-arrow"></span>
        <div class="header">
          Notifications ({{ notifications ? notifications.length : 0}})
        </div>
        <div class="section">
          <ul class="notificationsList" *ngIf="notifications && notifications.length">
            <li *ngFor="let notification of notifications.reverse()">
              <div class="notificationTitle">
                {{notification.title}}
              </div>
              <div class="notificationBody">
                {{notification.body}}
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div>
      <ul class="pull-right nav-tab">
        <li class="nav-li" routerLinkActive="nav-selected">
          <!-- <a routerLink="/open-bids" class="nav-page" matBadge="3" matBadgeOverlap="false" matBadgeColor="warn"> Open Bids</a> -->
          <a routerLink="/overview" class="nav-page">{{'HEADER.overview' | translate}}</a>
        </li>
        <li class="nav-li" routerLinkActive="nav-selected">
          <!-- <a routerLink="/open-bids" class="nav-page" matBadge="3" matBadgeOverlap="false" matBadgeColor="warn"> Open Bids</a> -->
          <a routerLink="/open-bids" class="nav-page">{{'HEADER.openBids' | translate}}</a>
        </li>
        <li class="nav-li" routerLinkActive="nav-selected">
          <a routerLink="/bid-orders" class="nav-page">{{'HEADER.myBids' | translate}}</a>
        </li>
        <li class="nav-li" routerLinkActive="nav-selected">
          <a routerLink="/controlRoom" class="nav-page">Control Room</a>
        </li>

        <li class="nav-li" routerLinkActive="nav-selected">

          <a routerLink="/dashboard" class="nav-page">{{'HEADER.myOrders' | translate}}</a>
        </li>


      </ul>
    </div>
  </div>
  <!-- <div *ngIf="loader.isLoading | async" class="pLoader">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div> -->

</div>